module.exports = __webpack_public_path__ + "static/media/img_banner4.e3c82eac.svg";